import { DayjsFormatTypes } from "../utils";
export default (function (format, isEnglish) {
  switch (format) {
    case DayjsFormatTypes.Date:
      return isEnglish ? 'll' : 'L';

    case DayjsFormatTypes.FullDate:
      return isEnglish ? 'lll' : 'L LT';

    case DayjsFormatTypes.MMMM_YYYY:
      return 'MMMM YYYY';

    case DayjsFormatTypes.MMMM:
      return 'MMMM';

    case DayjsFormatTypes.YYYY:
      return 'YYYY';

    case DayjsFormatTypes.MMM_YYYY:
      return 'MMM YYYY';

    case DayjsFormatTypes.ShortDate:
      return 'L';

    default:
      return format;
  }
});